import { Box, Button, DialogProps } from "@mui/material";
import BasicModal from "../../components/modal/BasicModal";
import useCaseNotes from "../../../hooks/useCaseNote";
import { User } from "../../../types/users";
import { useSnackbarHelper } from "../../components/Snackbar";
import useDocuments from "../../../hooks/useDocuments";
import { useState } from "react";
interface Props extends DialogProps {
  onClose: () => void;
  caseId?: string;
  documentId?: any;
}

const DeleteUserModal = ({ onClose, caseId, documentId, ...props }: Props) => {
  const [staticLoader,setStaticLoader] = useState(false)
  const showSnackbar = useSnackbarHelper();
  const { deleteDocument, isLoading } = useDocuments({
    caseId: caseId,
  });
  const onSubmit = async () => {
    try {
      setStaticLoader(true)
      const data: any = await deleteDocument({ documentId });
      // const message = data?.message || "Success";
      // showSnackbar(message, "success");
      // onClose();
      setTimeout(() => {
      const message = data?.message || "Success";
      showSnackbar(message, "success");
      setStaticLoader(false);
      document.getElementById("Refetch-document")?.click()
      onClose();
    }, 10000);
    } catch (error: any) {
      // const message = error?.response?.data?.message || "An error occurred";

      // showSnackbar(message, "error");
       setTimeout(() => {
      const message = error?.response?.data?.message || "An error occurred";
      showSnackbar(message, "error");
      setStaticLoader(false);
    }, 10000);
    }
  };

  return (
    <Box>
      <BasicModal
        onClose={onClose}
        isLoader={isLoading || staticLoader}
        loadingTitle="Loading..."
        title="Delete Document"
        content="Do you really want to delete this document? "
        actions={
          <>
            <Button
              variant="contained"
              color="error"
              sx={{ textTransform: "capitalize" }}
              onClick={onSubmit}
              disabled={isLoading || staticLoader}
            >
              Delete
            </Button>
            <Button
              variant="outlined"
              sx={{ textTransform: "capitalize" }}
              onClick={() => onClose()}
              color="error"
              disabled={isLoading || staticLoader}
            >
              Cancel
            </Button>
          </>
        }
        {...props}
      />
    </Box>
  );
};

export default DeleteUserModal;
